// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Nxfx","search":"Settings_search__26soY","filter":"Settings_filter__aKDzi"};